import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ActionCarousel = ({ title, subtitle, cards }) => {
  const scrollerRef = useRef(null);

  const scrollByCard = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const first = el.querySelector('[data-card="1"]');
    const cardWidth = first ? first.getBoundingClientRect().width : 320;
    el.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
  };

  return (
    <div className="w-full">
      <div className="flex items-end justify-between mb-6">
        <div>
          {subtitle ? <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">{subtitle}</p> : null}
          {title ? <h2 className="text-4xl md:text-5xl tracking-tight text-[#EDEDED]">{title}</h2> : null}
        </div>
        <div className="hidden md:flex items-center gap-2">
          <button
            onClick={() => scrollByCard(-1)}
            className="w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 flex items-center justify-center text-[#EDEDED]"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={() => scrollByCard(1)}
            className="w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 flex items-center justify-center text-[#EDEDED]"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div
        ref={scrollerRef}
        className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 scrollbar-hide"
      >
        {cards.map((c, idx) => (
          <div
            key={c.title}
            data-card="1"
            className="min-w-[280px] max-w-[320px] snap-start glass-card p-5"
          >
            <div className="text-lg font-medium text-[#EDEDED]">{c.title}</div>
            {c.subtitle ? <div className="text-sm text-[#A1A1AA] mt-1">{c.subtitle}</div> : null}

            <div className="mt-4 flex flex-col gap-2">
              {c.actions.map((a, j) => (
                <a
                  key={a.href}
                  href={a.href}
                  className="btn-secondary text-sm px-4 py-2"
                >
                  {a.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActionCarousel;
